import * as React from 'react';

import { EContainerTypes } from '../../types';
import { AddLabelWithoutProfilingContainer } from '../AddLabelWithoutProfilingContainer';
import { FormFailedContainer } from '../FormFailedContainer';
import { MainFormQuestionContainer } from '../MainFormQuestionContainer';
import { LabelAddedContainer } from '../LabelAddedContainer';
import { LabelRemovedContainer } from '../LabelRemovedContainer';

export interface IContainerProps {
  containerType: EContainerTypes;
}

export const LabelMapperContainer: React.FC<IContainerProps> = ({ containerType }) => {
  switch (containerType) {
    case EContainerTypes.NullContainer:
      return null;
    case EContainerTypes.AddLabelWithoutProfiling:
      return <AddLabelWithoutProfilingContainer />;
    case EContainerTypes.FormFailed:
      return <FormFailedContainer />;
    case EContainerTypes.IsMorgageQuestion:
      return <MainFormQuestionContainer containerType={containerType} />;
    case EContainerTypes.MaternityCapitalQuestion:
      return <MainFormQuestionContainer containerType={containerType} />;
    case EContainerTypes.OwnerCitizenshipQuestion:
      return <MainFormQuestionContainer containerType={containerType} />;
    case EContainerTypes.EncumbranceWillBeRemoved:
      return <MainFormQuestionContainer containerType={containerType} />;
    case EContainerTypes.LabelAdded:
      return <LabelAddedContainer />;
    case EContainerTypes.LabelRemoved:
      return <LabelRemovedContainer />;
    default:
      return null;
  }
};
